import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import Header from '../components/header'

import '../styles/reset.scss'
import '../styles/main.scss'


const Layout = ({ children, data }) => (
  <div>
    <Helmet
      title={'Marian Gibala'}
      meta={[
        { name: 'description', content: 'Marian Gibala' },
        { name: 'keywords', content: 'Marian Gibala' },
      ]}
    />
    <Header siteTitle={'Marian Gibala'} />
    <div
      style={{
        margin: '0 auto',
        maxWidth: 960,
        padding: '3rem',
        display: 'flex',
        justifyContent: 'center'
      }}
    >
      {children()}
    </div>
  </div>
)

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout



// WEBPACK FOOTER //
// ./src/layouts/index.js